import { useSearchParams } from 'react-router-dom'
import { readVista } from '@/components/planning/ViewModeSelect'
import { useFiltrosPersistentes } from '@/hooks/useFiltrosPersistentes'
import GanttPage from '@/pages/GanttPage'

/**
 * Planificación Avanzada: una única ruta (`/gantt`) cuyo rango temporal se elige
 * con `?vista=semanal|mensual|anual`. El rango es un parámetro de `GanttPage`,
 * no una página distinta: la geometría del eje la aporta el `TimeTrack` y los
 * filtros se comparten entre rangos (store).
 *
 * El rango se recuerda durante la sesión. El enlace del menú lateral apunta a
 * `/gantt` pelado, así que sin esto volver desde otra pantalla devolvía siempre
 * al semanal aunque estuvieras en el anual — y como el rango decide qué datos se
 * piden, no era sólo un cambio de eje: se perdía la consulta entera.
 *
 * Va aquí y no en `GanttPage` porque este componente es quien lee `vista` de la
 * URL: `paramsIniciales` ya trae lo recordado en el PRIMER render, antes de que
 * `GanttPage` monte y dispare su consulta con el rango equivocado.
 *
 * Los demás filtros del Gantt no pasan por aquí: viven en el store de Zustand,
 * que sobrevive al cambio de pantalla por su cuenta.
 */
export default function PlanificacionAvanzadaPage() {
  const [params] = useSearchParams()
  const { paramsIniciales } = useFiltrosPersistentes('gantt')

  // `paramsIniciales` se congela en el primer render, así que NO puede ser la
  // fuente permanente: si lo fuera, cambiar de rango con el selector no haría
  // nada. Sólo cubre ese primer render, cuando la URL todavía está pelada; en
  // cuanto el hook la repone —o el usuario elige rango— vuelve a mandar la URL.
  const vista = readVista(params.get('vista') ? params : paramsIniciales)

  return <GanttPage vista={vista} />
}
